import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import Raven from 'raven-js';
import { useGlobalAlertStore } from '../../../hooks/useGlobalAlertStore';
import { isRpcError } from '../../../utils/error';
import { trackRequestSeatClick } from '../../../utils/metrics';
import { isUpgradePoint, trackPotentialBannerInteraction } from '../../../utils/ums';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { RequestSeatModal } from './RequestSeatModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestSeatButtonBase = ({
  apiName,
  children,
  level,
  location,
  showSeatSelector = true,
  trackingData,
  uiButtonProps,
  upgradeConfig,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId
}) => {
  const {
    alertStore,
    shouldRenderGlobalList
  } = useGlobalAlertStore();
  const [showModal, setShowModal] = useState(false);
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'REQUEST_SEAT'
  }), [apiName, trackingData, upgradeConfig]);
  useEffect(() => {
    track('interaction', Object.assign({
      action: 'viewed request seat'
    }, trackingProperties, {
      isPrimaryCta: level === 0,
      isSecondaryCta: level === 1
    }));
  }, [trackingProperties, level]);
  const handleClick = () => {
    setShowModal(true);
    track('interaction', Object.assign({
      action: 'clicked request seat'
    }, trackingProperties));
    trackRequestSeatClick({
      apiName,
      isEmbeddedInBanner: !!trackingData.usageLimitBannerData
    });
    if (isUpgradePoint(location)) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, trackingProperties));
      if (upgradeConfig) {
        trackPotentialBannerInteraction(upgradeConfig).catch(error => {
          if (!isRpcError(error) || error.cause.status !== 0) {
            Raven.captureException(error, {
              fingerprint: ['Failed to submit interaction from RequestSeatButton'],
              extra: {
                upgradeConfig
              }
            });
          }
        });
      }
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldRenderGlobalList && /*#__PURE__*/_jsx(FloatingAlertList, {
      "data-test-id": "global-floating-alert-list",
      alertStore: alertStore
    }), showModal && /*#__PURE__*/_jsx(RequestSeatModal, {
      alertStore: alertStore,
      apiName: apiName,
      setShowModal: setShowModal,
      showSeatSelector: showSeatSelector,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig
    }), /*#__PURE__*/_jsx(Button, Object.assign({
      truncate: true,
      truncateStringProps: {
        justifyContent: 'center'
      }
    }, uiButtonProps, {
      onClick: handleClick,
      "data-test-id": dataTestId,
      "data-selenium-id": dataSeleniumId,
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.buttons.requestSeat"
      })
    }))]
  });
};
export const RequestSeatButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.REQUEST_SEAT_BUTTON,
  children: /*#__PURE__*/_jsx(RequestSeatButtonBase, Object.assign({}, props))
});